import React from "react";

const SearchButton = () => <button className="btn btn-primary">Search</button>;

export default SearchButton;
